import React from 'react'
import { DefaultTheme, useTheme } from 'styled-components'
import { WebsiteLogoImageUi } from '../ui'

export interface WebsiteLogoPictureProps {
  alt: string
  mobileImageSrc: string
  imageSrc: string
  height?: number
  mobileHeight?: number
}

export const WebsiteLogoPicture = ({
  alt,
  mobileImageSrc,
  imageSrc,
  height,
  mobileHeight,
}: WebsiteLogoPictureProps) => {
  const stripAtMedia = (media?: string) =>
    media?.trim().replace(/^@media\s*/i, '')
  const theme = useTheme() as DefaultTheme
  const mediaCond = stripAtMedia(theme?.phone)
  const hasMobile = Boolean(mobileImageSrc && mobileImageSrc !== imageSrc)
  return (
    <picture>
      {theme?.isEditorMobileMode && hasMobile && (
        <source media="all" srcSet={mobileImageSrc} />
      )}

      {hasMobile && mediaCond && (
        <source media={mediaCond} srcSet={mobileImageSrc} />
      )}
      <WebsiteLogoImageUi
        src={imageSrc}
        alt={alt}
        imageSrc={imageSrc}
        mobileImageSrc={mobileImageSrc}
        height={height}
        mobileHeight={mobileHeight}
      />
    </picture>
  )
}
